export const MICROSOFT_AUTHENTICATOR =
  "https://www.microsoft.com/en-us/security/mobile-authenticator-app";

export const GOOGLE_AUTHENTICATOR =
  "https://support.google.com/accounts/answer/1066447?hl=en&co=GENIE.Platform%3DAndroid";
